module.exports = __webpack_public_path__ + "img/slider_1.21ef0bde.jpg";